import React, { useState } from "react";
import { User, Phone, CreditCard, Shield, CheckCircle, Send, AlertCircle, X } from "lucide-react";
import useApi from "../../../CustomHooks/useApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Biometricdevices from "../../../ResuableCompoment/Biometricdevices";
import Biometricdeviceiserview from "../../../ResuableCompoment/Biometricdeviceiserview";

const RegisterCustomerinstpay = () => {
  const [aadhaar, setAadhaar] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [otpRef, setOtpRef] = useState("");
  const [verifyOtpRef, setverifyOtpRef] = useState("");
  const [pidData, setPidData] = useState(null);
  const [trxnId, setTrxnId] = useState("");
  const [kycToken, setKycToken] = useState("");
  const [info, setInfo] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  // const { name, mobile, publicIp, latlong, instRef, impsType } = location.state || {};
  const {
    name,
    mobile,
    publicIp,
    latlong,
    instRef,
    impsType,
    merchantId
  } = location.state || {};
  const safeName = name || "";
  const safeMobile = mobile || "";
  const safeAadhaar = aadhaar || "";
  const details = useSelector((store) => store?.auth?.employeeDetails);
  const coordinates = latlong;
  const [latitude, longitude] = coordinates.split("_");

  const { callApi: sendOtp } = useApi("/dmt/processCustomer", "POST");
  const { callApi: Verifyotp } = useApi("/dmt/processCustomer", "POST");
  const { callApi: finalregister } = useApi("/dmt/remitterKyc", "POST");
  const { callApi: verifyAadhaarOtp } = useApi(
    "/dmt/ezypay/verify/adhaar/otp",
    "POST"
  );
  const { callApi: ezypayBiometricKyc } = useApi(
    "/dmt/ezypay/remitter/kyc",
    "POST"
  );

  // const handleSendOtp = async () => {
  //   setError("");
  //   setSuccess("");

  //   if (!name.trim()) {
  //     setError("Full name is missing.");
  //     return;
  //   }
  //   if (!/^\d{10}$/.test(mobile)) {
  //     setError("Invalid 10-digit mobile number");
  //     return;
  //   }
  //   if (!/^\d{12}$/.test(aadhaar)) {
  //     setError("Invalid 12-digit Aadhaar number");
  //     return;
  //   }

  //   setIsLoading(true);

  //   const requestData = {
  //     name: name,
  //     mobile_number: mobile,
  //     adhaar: aadhaar,
  //     public_ip: publicIp,
  //     latlong: latlong,
  //     referenceKey: instRef,
  //     imps_type: impsType,
  //     merchant_id: details?.userId,
  //   };

  //   try {
  //     const response = await sendOtp(requestData);
  //     if (response?.statusCode === "ERR") {
  //       setError(response?.message);
  //       return;
  //     } else if (response?.statusCode === "OTP") {
  //       setSuccess(response?.message);
  //       setOtpSent(true);
  //       setOtpRef(response?.referenceKey);
  //     } else if (response?.statusCode === "IST") {
  //       setError(response?.message);
  //       return;
  //     } else {
  //       setError(response?.message);
  //     }

  //   } catch (error) {
  //     setError("Failed to send OTP. Try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSendOtp = async () => {
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      // const requestData = {
      //   mobile: mobile,
      //   aadhaar: aadhaar,
      //   user_name: details?.username,
      //   type: impsType, // IMPS1 or IMPS2
      // };
      const requestData = {
        adhaar: aadhaar,                    // spelling required by backend
        imps_type: impsType,               // IMPS1 / IMPS2
        latlong: latlong,
        merchant_id: merchantId,
        mobile_number: mobile,
        name: name,
        public_ip: publicIp,
        username: details?.username,
        referenceKey: instRef        // from verifyCustomer
      };

      const response = await sendOtp(requestData);

      /* ================= IMPS2 (KEEP EXISTING BEHAVIOR) ================= */
      if (impsType === "IMPS2") {
        if (response?.statusCode === "OTP") {
          setSuccess(response?.message);
          setOtpSent(true);
          setOtpRef(response?.referenceKey);
          return;
        }

        if (
          response?.statusCode === "IST" ||
          response?.statusCode === "ERR"
        ) {
          setError(response?.message);
          return;
        }

        setError(response?.message || "Failed to send OTP");
        return;
      }

      /* ================= IMPS1 (NEW LOGIC) ================= */
      // if (impsType === "IMPS1") {
      //   if (response?.referenceKey) {
      //     setSuccess(
      //       response?.message ||
      //         "OTP sent successfully for Aadhaar verification"
      //     );
      //     setOtpSent(true);
      //     setOtpRef(response.referenceKey);
      //     return;
      //   }

      //   setError(
      //     response?.message ||
      //       "Failed to initiate Aadhaar verification"
      //   );
      if (impsType === "IMPS1") {
        if (response?.error_code === "DMT001") {
          setSuccess(response?.message || "OTP sent successfully");
          setOtpSent(true);

          // ✅ STORE trxnId FOR VERIFY STEP
          setTrxnId(response?.action_params?.trxnId);

          return;
        }

        setError(response?.message || "Failed to send OTP");

      }
    } catch (err) {
      setError("Server error while sending OTP");
    } finally {
      setIsLoading(false);
    }
  };


  // const handleVerifyOtp = async () => {
  //   setError("");
  //   setSuccess("");

  //   if (otp.length !== 6) {
  //     setError("Please enter a valid 6-digit OTP");
  //     return;
  //   }

  //   setIsLoading(true);

  //   const requestData = {
  //     name: name,
  //     mobile_number: mobile,
  //     public_ip: publicIp,
  //     latlong: latlong,
  //     referenceKey: otpRef,
  //     otp: otp,
  //     imps_type: impsType,
  //     merchant_id: details?.userId,
  //   };

  //   try {
  //     const response = await Verifyotp(requestData);
  //     console.log("OTP sent response:", response);
  //     if (response?.statusCode === "OTP_FAILED") {
  //       setError(response?.message);
  //       setOtpSent(false);
  //       setOtp("");
  //       return;
  //     } else if (response?.statusCode === "KYC") {
  //       setSuccess(response?.message);
  //       setverifyOtpRef(response?.referenceKey);
  //       setOtpVerified(true);
  //       setOtpSent(false);
  //       setOtp("");
  //     } else if (response?.statusCode === "EOP") {
  //       setError(response?.message);
  //       setOtpSent(false);
  //       setOtp("");
  //     } else {
  //       setError(response?.message);
  //       setOtpSent(false);
  //       setOtp("");
  //     }
  //   } catch (error) {
  //     setError("Failed to send OTP. Try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleVerifyOtp = async () => {
  //   setError("");
  //   setSuccess("");
  //   setIsLoading(true);

  //   try {
  //     // const requestData = {
  //     //   mobile: mobile,
  //     //   otp: otp,
  //     //   referenceKey: otpRef,
  //     //   user_name: details?.username,
  //     //   type: impsType, // IMPS1 or IMPS2
  //     // };
  //     const requestData = {
  //       adhaar: aadhaar,
  //       otp: otp,
  //       imps_type: impsType,
  //       latlong: latlong,
  //       merchant_id: merchantId,
  //       mobile_number: mobile,
  //       name: name,
  //       public_ip: publicIp,
  //       // username: details?.username,
  //       referenceKey: otpRef || instRef
  //     };

  //     const response = await Verifyotp(requestData);

  //     /* ================= IMPS2 (KEEP EXISTING BEHAVIOR) ================= */
  //     if (impsType === "IMPS2") {
  //       if (response?.statusCode === "KYC") {
  //         setSuccess(response?.message);
  //         setverifyOtpRef(response?.referenceKey);
  //         setOtpVerified(true);
  //         setOtpSent(false);
  //         setOtp("");
  //         return;
  //       }

  //       if (
  //         response?.statusCode === "OTP_FAILED" ||
  //         response?.statusCode === "EOP"
  //       ) {
  //         setError(response?.message);
  //         return;
  //       }

  //       setError(response?.message || "OTP verification failed");
  //       return;
  //     }

  //     /* ================= IMPS1 (NEW LOGIC) ================= */
  //     // if (impsType === "IMPS1") {
  //     //   if (response?.referenceKey) {
  //     //     setSuccess(
  //     //       response?.message || "OTP verified successfully"
  //     //     );
  //     //     setverifyOtpRef(response.referenceKey);
  //     //     setOtpVerified(true);
  //     //     setOtpSent(false);
  //     //     setOtp("");
  //     //     return;
  //     //   }

  //     //   setError(response?.message || "OTP verification failed");
  //     // }
  //     if (impsType === "IMPS1") {
  //       const requestData = {
  //         sendermobile: mobile,
  //         identifier: trxnId,   // ✅ trxnId goes here
  //         otp: otp,
  //         imps_type: "IMPS1"   // ✅ correct value
  //       };

  //       const response = await verifyAadhaarOtp(requestData);

  //       if (response?.status === 200 || response?.error_code === "SUCCESS") {
  //         setSuccess("Aadhaar OTP verified successfully");
  //         setOtpVerified(true);
  //         setOtpSent(false);
  //         setOtp("");
  //         return;
  //       }

  //       setError(response?.message || "OTP verification failed");
  //     }
  //   } catch (err) {
  //     setError("Server error while verifying OTP");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleVerifyOtp = async () => {
    setError("");
    setSuccess("");
    setIsLoading(true);

    if (!(otp.length === 4 || otp.length === 6)) {
      setError("OTP must be 4 or 6 digits");
      setIsLoading(false);
      return;
    }

    try {
      /* ================= IMPS1 — EZYPAY ONLY ================= */
      if (impsType === "IMPS1") {
        const requestData = {
          sendermobile: mobile,
          identifier: trxnId,   // ✅ trxnId goes here
          otp: otp,
          imps_type: "IMPS1"
        };

        const response = await verifyAadhaarOtp(requestData);

        // if (response?.status === 200 || response?.error_code === "SUCCESS") {
        //   setSuccess("Aadhaar OTP verified successfully");
        //   setOtpVerified(true);
        //   setOtpSent(false);
        //   setOtp("");
        //   return; // 🔥 STOP EXECUTION HERE
        // }

        // setError(response?.message || "OTP verification failed");
        if (response?.status === "SUCCESS" && response?.kycToken) {
          setSuccess("Aadhaar OTP verified successfully");

          // ✅ mark OTP verified → biometric screen will show
          setKycToken(response.kycToken);
          setOtpVerified(true);
          setOtpSent(false);
          setOtp("");

          // (optional) store kycToken if needed later
          // setKycToken(response.kycToken);

          return; // 🔥 STOP HERE — NO ERROR SHOULD SHOW
        }

        // ❌ only reach here if response is NOT success
        setError(response?.message || "OTP verification failed");
        return; // 🔥 VERY IMPORTANT
      }

      /* ================= IMPS2 — EXISTING FLOW ================= */
      const requestData = {
        adhaar: aadhaar,
        otp: otp,
        imps_type: impsType,
        latlong: latlong,
        merchant_id: merchantId,
        mobile_number: mobile,
        name: name,
        public_ip: publicIp,
        referenceKey: otpRef || instRef
      };

      const response = await Verifyotp(requestData);

      if (response?.statusCode === "KYC") {
        setSuccess(response?.message);
        setverifyOtpRef(response?.referenceKey);
        setOtpVerified(true);
        setOtpSent(false);
        setOtp("");
        return;
      }

      setError(response?.message || "OTP verification failed");

    } catch (err) {
      setError("Server error while verifying OTP");
    } finally {
      setIsLoading(false);
    }
  };


  const dismissMessage = () => {
    setError("");
    setSuccess("");
  };

  // const FinalRegistration = async () => {

  //   setError("");
  //   setSuccess("");

  //   if (!pidData) {
  //     setError("Please Do Biometric Verification");
  //     setIsLoading(false);
  //     return
  //   }

  //   setIsLoading(true);

  //   const requestData = {
  //     name: name,
  //     mobileNumber: mobile,
  //     public_ip: publicIp,
  //     latitude: latitude,
  //     longitude: longitude,
  //     referenceKey: verifyOtpRef,
  //     biometricData: pidData,
  //     consentTaken: "Y",
  //     imps_type: impsType,
  //     merchant_id: details?.userId,
  //   };

  //   try {
  //     const response = await finalregister(requestData);
  //     if (response?.statusCode === "TXN") {
  //       setSuccess(response?.message);
  //       navigate("/remittance");
  //       setPidData(null);
  //     } else {
  //       setError(response?.message);
  //       setPidData(null);
  //     }
  //   } catch (error) {
  //     setError("Failed to send OTP. Try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }

  // }

  // const isFormValid = name.trim() && mobile.length === 10 && aadhaar.length === 12;

  const FinalRegistration = async () => {
    setError("");
    setSuccess("");
    setInfo("");

    if (!pidData) {
      setError("Please do biometric verification");
      return;
    }

    setIsLoading(true);

    try {
      /* ================= IMPS1 — EZYPAY BIOMETRIC KYC ================= */
      if (impsType === "IMPS1") {
        const payload = {
          senderMobile: mobile,
          kycToken: kycToken,     // ✅ from Aadhaar OTP verify
          encData: pidData,       // ✅ Base64 from biometricdeviceiserview
          imps_type: "IMPS1"
        };

        const response = await ezypayBiometricKyc(payload);

        // if (response?.status === "SUCCESS") {
        //   setSuccess("Biometric KYC completed successfully");
        //   navigate("/remittance");
        //   setPidData(null);
        //   return;
        // }

        // setError(response?.message || "Biometric KYC failed");
        // return;
        // const message = response?.desc?.trim();

        // switch (response?.status) {
        //   case "SUCCESS":
        //     setSuccess(message || "Biometric KYC completed successfully");
        //     setPidData(null);
        //     navigate("/remittance");
        //     return;

        //   case "PENDING":
        //     setSuccess(message || "Biometric KYC is pending");
        //     return;

        //   case "INITIATED":
        //     setSuccess(message || "Biometric KYC initiated");
        //     return;

        //   case "FAILED":
        //     setError(message || "Biometric KYC failed");
        //     return;

        //   default:
        //     setError(message || "Unable to process biometric KYC response");
        //     return;
        // }
        const message = response?.desc?.trim();

switch (response?.status) {
  case "SUCCESS":
    setSuccess(message);
    setInfo("");
    setError("");
    setPidData(null);
    navigate("/remittance");
    return;

  case "INITIATED":
  case "PENDING":
    setInfo(message);     // ✅ INFO, not success
    setSuccess("");
    setError("");
    return;

  case "FAILED":
    setError(message);
    setSuccess("");
    setInfo("");
    return;

  default:
    setError(message || "Unexpected biometric KYC response");
    setSuccess("");
    setInfo("");
    return;
}

      }

      /* ================= IMPS2 — DO NOT CHANGE ================= */
      const requestData = {
        name: name,
        mobileNumber: mobile,
        public_ip: publicIp,
        latitude: latitude,
        longitude: longitude,
        referenceKey: verifyOtpRef,
        biometricData: pidData,
        consentTaken: "Y",
        imps_type: impsType,
        merchant_id: details?.userId,
      };

      const response = await finalregister(requestData);

      if (response?.statusCode === "TXN") {
        setSuccess(response?.message);
        navigate("/remittance");
        setPidData(null);
      } else {
        setError(response?.message);
        setPidData(null);
      }

    } catch (error) {
      setError("Failed to complete biometric verification");
    } finally {
      setIsLoading(false);
    }
  };


  const isFormValid =
    // safeName.trim().length > 0 &&
    safeMobile.length === 10 &&
    safeAadhaar.length === 12;

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-[46rem]">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-4">
            <User className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Register Customer</h1>
          <p className="text-gray-600">Create your account to get started</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="space-y-6">
            {/* Name (Always Disabled) */}
            {/* <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                <User className="w-4 h-4" />
                Full Name
              </label>
              <input
                type="text"
                value={name}
                disabled
                className="w-full px-4 py-3 border bg-gray-100 text-gray-500 border-gray-300 rounded-xl"
              />
            </div> */}

            {/* Mobile (Always Disabled) */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                <Phone className="w-4 h-4" />
                Mobile Number
              </label>
              <input
                type="text"
                value={mobile}
                disabled
                className="w-full px-4 py-3 border bg-gray-100 text-gray-500 border-gray-300 rounded-xl"
              />
            </div>

            {/* Aadhaar (Disabled after OTP verification) */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                <CreditCard className="w-4 h-4" />
                Aadhaar Number
              </label>
              <input
                type="text"
                placeholder="Enter 12-digit Aadhaar number"
                value={aadhaar}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,12}$/.test(val)) setAadhaar(val);
                }}
                disabled={otpVerified}
                className={`w-full px-4 py-3 border border-gray-300 rounded-xl ${otpVerified
                  ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
                  : 'focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
              />
            </div>

            {/* Show buttons only when OTP is not verified */}
            {!otpVerified && (
              <>
                {!otpSent ? (
                  <button
                    onClick={handleSendOtp}
                    disabled={!isFormValid || isLoading}
                    className={`w-full py-3 px-4 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 ${isFormValid && !isLoading
                      ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:from-blue-600 hover:to-purple-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                  >
                    {isLoading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <>
                        <Send className="w-5 h-5" />
                        Send OTP
                      </>
                    )}
                  </button>
                ) : (
                  <div className="space-y-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                      <div className="flex items-center gap-2 text-blue-700">
                        <Shield className="w-5 h-5" />
                        <span className="font-medium">OTP sent to +91 {mobile}</span>
                      </div>
                      <p className="text-sm text-blue-600 mt-1">Please check your messages</p>
                    </div>

                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                        <Shield className="w-4 h-4" />
                        Verification Code
                      </label>
                      <input
                        type="text"
                        placeholder="Enter 4 or 6 digit OTP"
                        value={otp}
                        // onChange={(e) => {
                        //   const val = e.target.value;
                        //   if (/^\d{0,6}$/.test(val)) setOtp(val);
                        // }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,6}$/.test(val)) {
                            setOtp(val);
                          }
                        }}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-center tracking-widest"
                      />
                    </div>

                    <button
                      onClick={handleVerifyOtp}
                      // disabled={otp.length !== 6 || isLoading}
                      disabled={!(otp.length === 4 || otp.length === 6) || isLoading}
                      className={`w-full py-3 px-4 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 ${(otp.length === 4 || otp.length === 6) && !isLoading
                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                      {isLoading ? (
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      ) : (
                        <>
                          <CheckCircle className="w-5 h-5" />
                          Verify OTP
                        </>
                      )}
                    </button>
                  </div>
                )}
              </>
            )}

            {/* Show success message and biometric component after OTP verification */}
            {otpVerified && (
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                      <CheckCircle className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-green-800 text-lg">OTP Verified Successfully!</h3>
                      <p className="text-sm text-green-700 mt-1">
                        Please complete biometric verification to finish registration.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Biometric Component */}
                {/* <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
                  <h3 className="font-semibold text-gray-800 mb-4">Biometric Verification</h3>
                  <Biometricdevices setPidData={setPidData} />
                </div> */}
                <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
                  <h3 className="font-semibold text-gray-800 mb-4">Biometric Verification</h3>

                  {impsType === "IMPS1" ? (
                    <Biometricdeviceiserview setPidData={setPidData} />
                  ) : (
                    <Biometricdevices setPidData={setPidData} />
                  )}

                </div>

                {/* Submit Button */}

                <button
                  className={`w-full py-3 px-4 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 ${pidData && !isLoading
                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                  disabled={isLoading}
                  onClick={FinalRegistration}
                >
                  {isLoading ? (
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  ) : (
                    <>
                      <CheckCircle className="w-5 h-5" />
                      Complete Registration
                    </>
                  )}
                </button>

              </div>
            )}


            {error && (
              <div className="mb-6 bg-red-50 border border-red-200 rounded-xl p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <AlertCircle className="w-5 h-5 text-red-500" />
                    <div>
                      <h3 className="font-medium text-red-800">Error</h3>
                      <p className="text-sm text-red-700 mt-1">{error}</p>
                    </div>
                  </div>
                  <button onClick={dismissMessage} className="text-red-400 hover:text-red-600">
                    <X className="w-5 h-5" />
                  </button>
                </div>
              </div>
            )}

            {info && (
  <div className="mb-6 bg-blue-50 border border-blue-200 rounded-xl p-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Shield className="w-5 h-5 text-blue-500" />
        <div>
          <h3 className="font-medium text-blue-800">Information</h3>
          <p className="text-sm text-blue-700 mt-1">{info}</p>
        </div>
      </div>
      <button
        onClick={() => setInfo("")}
        className="text-blue-400 hover:text-blue-600"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  </div>
)}

            {success && (
              <div className="mb-6 bg-green-50 border border-green-200 rounded-xl p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <div>
                      <h3 className="font-medium text-green-800">Success</h3>
                      <p className="text-sm text-green-700 mt-1">{success}</p>
                    </div>
                  </div>
                  <button onClick={dismissMessage} className="text-green-400 hover:text-green-600">
                    <X className="w-5 h-5" />
                  </button>
                </div>
              </div>
            )}
          </div>


        </div>

        <div className="text-center mt-8 text-sm text-gray-600">
          <p>By registering, you agree to our Terms of Service and Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default RegisterCustomerinstpay;